/** Brand mark for Root & Rose: the red spiral rose with roots (from /public/brand/mark.png). */
export function RoseMark({ className = "w-5 h-5" }) {
  return <img src="/brand/mark-256.png" alt="" aria-hidden="true" className={`${className} object-contain select-none`} draggable={false} data-testid="rose-mark" />;
}
